import type { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export function Layout({ children }: PropsWithChildren) {
  const { t } = useTranslation('navigation', {
    keyPrefix: 'sidebar.items',
  });

  return (
    <>
      <Helmet>
        <title>{t('campaign-planner')}</title>
      </Helmet>

      <main className="h-full bg-gradient bg-[100%,auto] bg-no-repeat p-xl bg-level-01/full">
        {children}
      </main>
    </>
  );
}

Layout.displayName = 'Layout';
